import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { DeliveryOrder } from "../models/deliveryOrder";
import { DeliveryOrderService } from "../services/deliveryOrder.service";

@Injectable()
export class DeliveryOrderResolver implements Resolve<DeliveryOrder> {
  constructor(private service: DeliveryOrderService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<DeliveryOrder> {
    const id = Number(route.paramMap.get("id"));
    if (id != 0) {
      return this.service.getDeliveryOrderById(+id);
    } else {
      return null;
    }
  }
}
